module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideout-container active"
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_c('div', {
    staticClass: "panel-inner"
  }, [_c('div', {
    staticClass: "content-panel-body"
  }, [_c('h3', {
    staticClass: "step-name"
  }, [_vm._t("title")], 2), _vm._v(" "), _vm._t("body")], 2)])]), _vm._v(" "), _vm._t("addition")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4d29b4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/StepSlideoutModal/SlideoutContainer.vue
// module id = CUlj
// module chunks = 1